import { MENU_KEYS } from '../../../../config/constants';
import { isRemoteIntialised } from '@mindtickle/ui-shell-core/DynamicRemote';
import { MixpanelEventNameType, MixpanelTrackType } from '~/components/GlobalHeader/Admin/type';
import { DYNAMIC_REMOTES } from '~/config/app.constants';
import { MIXPANEL_EVENTS } from '../../../../mixpanel/config';
import SwitchDomain from './SwitchDomain';
import withAdminAccess from './withAdminAccess';

type SendAnnouncementProps = {
  onHideDropdownContent: Function;
  track: MixpanelTrackType<MixpanelEventNameType>;
  company: any;
  user: any;
};

const SendAnnouncement = ({ onHideDropdownContent, track }: SendAnnouncementProps) => (
  <SwitchDomain
    eventName={MIXPANEL_EVENTS.ANNOUNCEMENT}
    defer={() => isRemoteIntialised(DYNAMIC_REMOTES.ANNOUNCEMENT.remoteName)}
    onHideDropdownContent={onHideDropdownContent}
    track={track}
    domain={DYNAMIC_REMOTES.ANNOUNCEMENT}
    menuKey={MENU_KEYS.ANNOUNCEMENT}
    className="styled-content"
  />
);

export default withAdminAccess(SendAnnouncement);
